import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.anim__fade-up')) {
	const rows = gsap.utils.toArray('.anim__fade-up');
	gsap.defaults({ ease: 'power2.out' });
	gsap.set(rows, { y: 50, autoAlpha: 0 });
	ScrollTrigger.batch(rows, {
		start: 'top bottom-=100px',
		onEnter: (batch) =>
			gsap.to(batch, {
				duration: 2,
				autoAlpha: 1,
				y: 0,
				stagger: 0.2,
			}),
	});
}
